/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_RefocusInputs */

const bn_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিফোকাস`)
};

const de_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konzentrieren Sie sich neu`)
};

const el_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επαναεστίαση`)
};

const en_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refocus`)
};

const es_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenfocar`)
};

const fr_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recentrer`)
};

const hi_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फिर से फ़ोकस`)
};

const hu_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fókuszálás újra`)
};

const id_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokus kembali`)
};

const it_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimessa a fuoco`)
};

const ja_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`焦点を合わせ直す`)
};

const ko_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초점을 다시 맞추세요`)
};

const nl_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heroriënteren`)
};

const pl_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmień ostrość`)
};

const pt_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refocar`)
};

const ru_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переориентация`)
};

const sv_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokusera om`)
};

const tr_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeniden odaklama`)
};

const uk_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перефокусувати`)
};

const vi_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lấy nét lại`)
};

const zh_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新聚焦`)
};

const zh_hant_action_refocus = /** @type {(inputs: Action_RefocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新聚焦`)
};

/**
* | output |
* | --- |
* | "Refocus" |
*
* @param {Action_RefocusInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const action_refocus = /** @type {((inputs?: Action_RefocusInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_RefocusInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_action_refocus(inputs)
	if (locale === "de") return de_action_refocus(inputs)
	if (locale === "el") return el_action_refocus(inputs)
	if (locale === "en") return en_action_refocus(inputs)
	if (locale === "es") return es_action_refocus(inputs)
	if (locale === "fr") return fr_action_refocus(inputs)
	if (locale === "hi") return hi_action_refocus(inputs)
	if (locale === "hu") return hu_action_refocus(inputs)
	if (locale === "id") return id_action_refocus(inputs)
	if (locale === "it") return it_action_refocus(inputs)
	if (locale === "ja") return ja_action_refocus(inputs)
	if (locale === "ko") return ko_action_refocus(inputs)
	if (locale === "nl") return nl_action_refocus(inputs)
	if (locale === "pl") return pl_action_refocus(inputs)
	if (locale === "pt") return pt_action_refocus(inputs)
	if (locale === "ru") return ru_action_refocus(inputs)
	if (locale === "sv") return sv_action_refocus(inputs)
	if (locale === "tr") return tr_action_refocus(inputs)
	if (locale === "uk") return uk_action_refocus(inputs)
	if (locale === "vi") return vi_action_refocus(inputs)
	if (locale === "zh") return zh_action_refocus(inputs)
	return zh_hant_action_refocus(inputs)
});